import React, { useState, useEffect } from "react";
import { Grid, Paper } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { DatePickerInput } from "rc-datepicker";
import { Link } from 'react-router-dom';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import Modal_Frame from "../biztran_controls/Modal_Frame";
import Moment from "moment";
import UseFetchData from "../../hooks/UseFetchData";
import BiztranControls from "../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../biztran_controls_formik/BiztranControlsFormik";
import Data_Grid from "../biztran_controls/DataGrid";
import CreateMfgBatch from "./CreateMfgBatch";
import CreateSerialNumber from "./CreateSerialNumber";
import { makeStyles } from "@material-ui/styles";
import * as Yup from "yup";
import LogoColor from "../../assets/img/logo/corob.png";
//import Logo2 from "../../assets/img/corobnew.png"
//import AddExpenseSheet from "./AddExpenseSheet";
const todate = new Date()
const fromdate = todate.getFullYear() - 1 + '/04/01';



const Cecertificate = () => {
    const classes = useStyles();
    const [FromDate, setFromDate] = useState(fromdate);
    const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
    const [ToDate, setToDate] = useState(todate.toISOString());
    const [defaultToDate, setdefaultToDate] = useState(todate);
    const [isOpen, setOpen] = useState(false);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [Count, setCount] = useState();
    const [ModelName, setModelName] = useState('');
    const [ModelID, setModelID] = useState('');
    const [SerialNo, setSerialNo] = useState('');
    const [SerialNumber, setSerialNumber] = useState('');
    const [Statuscmb, setStatuscmb] = useState([]);
    const [MfgBatchID, setMfgBatchID] = useState('');
    const [MfgBatchNo, setMfgBatchNo] = useState('');
    const [MfgDate, setMfgDate] = useState('');
    const [MfgQty, setMfgQty] = useState('');
    const [Remarks, setRemarks] = useState('');
    const [CreatedByID, setCreatedByID] = useState('');
    const [CreatedOn, setCreatedOn] = useState('');
    const [ModifiedByID, setModifiedByID] = useState('');
    const [ModifiedOn, setModifiedOn] = useState('');
    const [ModelCode, setModelCode] = useState('');
    const [CEPath, setCEPath] = useState(null);
    const [WarrentyPath, setWarrentyPath] = useState(null);
    const [UserManualPath, setUserManualPath] = useState(null);
    const [KitPath, setKitPath] = useState(null);
    const [response, fetchData] = UseFetchData();
    const [responseCEPath, fetchCEPath] = UseFetchData();
    const [responseWarrantyPath, fetchWarrantyPath] = UseFetchData();
    const [responseModel, fetchModelData] = UseFetchData();
    const [responseModelDtls, fetchModelDtls] = UseFetchData();

    const validationSchema = Yup.object({

    });


    const onFromClear = () => {
        setFromDate();
        setdefaultfromDate();
    }

    const onToClear = () => {
        setToDate();
        setdefaultToDate();
    }

    const openModal = (row) => {
        setOpen(true);
        setMfgBatchID(row.id);
    };

    const handleOpenModal = () => {
        setMfgBatchID('');
        setOpen(true);
    };

    const PopulatebData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
        bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
        bodyFormData.append("MfgBatchID", MfgBatchID);
        bodyFormData.append("MfgBatchNo", MfgBatchNo);
        bodyFormData.append("MfgDate", MfgDate);
        bodyFormData.append("Remarks", Remarks);
        bodyFormData.append("MfgQty", MfgQty);
        bodyFormData.append("ModelName", ModelName);
        bodyFormData.append("ModelCode", ModelCode);
        bodyFormData.append("CreatedByID", CreatedByID);
        bodyFormData.append("CreatedOn", CreatedOn);
        bodyFormData.append("ModifiedByID", ModifiedByID);
        bodyFormData.append("ModifiedOn", ModifiedOn);
        fetchData("MfgBatch/List", bodyFormData);
    }

    const onSubmit = (values) => {
        var bodyFormData = new FormData();
    }
    const getModelPath = (ModelID) => {
        var bodyFormData = new FormData();
        bodyFormData.append("ModelID", ModelID);
        fetchModelData("Model/GetModelPath", bodyFormData);
    }

    const getModelDtls = (SerialNo) => {
        var bodyFormData = new FormData();
        bodyFormData.append("SerialNo", SerialNo);
        fetchModelDtls("Model/GetModelDtls", bodyFormData);
    }

    const downloadCECertificate = () => {
        debugger;
        //setOpen(true);
        var bodyFormData = new FormData();
        bodyFormData.append("ModelID", ModelID);
        bodyFormData.append("SerialNo", SerialNo);
        fetchCEPath("MfgBatch/GenerateCECertificate", bodyFormData);

    }
    const downloadWarrentyForm = () => {
        debugger;
        //setOpen(true);
        var bodyFormData = new FormData();
        bodyFormData.append("ModelID", ModelID);
        bodyFormData.append("SerialNo", SerialNo);
        fetchWarrantyPath("MfgBatch/GenerateWarranty", bodyFormData);
    }

    const downloadUserManual = () => {
        if (UserManualPath !== null && UserManualPath !== "") {
            window.open(UserManualPath);
        }
        else {
            alert("User Manual Not Found");
        }
    }

    const downloadKitInstruction = () => {
        debugger;
        if (KitPath !== null && KitPath !== "") {
            window.open(KitPath);
            console.log(KitPath);
        }
        else {
            alert("Kit Assembly Instructions Not Found");
        }
    }

    useEffect(() => {
        debugger;
        if (responseCEPath.Response === true) {
            window.open("/Files/CECertificate/CECertificate.pdf");
        }
    }, [responseCEPath]);

    useEffect(() => {
        debugger;
        if (responseWarrantyPath.Response === true) {
            window.open("Files/InstallationWarranty/InstallationWarranty.pdf");
        }
    }, [responseWarrantyPath]);


    useEffect(() => {
        debugger;
        if (responseModel.length > 0) {
            if (responseModel[0].UserManual !== null && responseModel[0].UserManual !== "") {
                setUserManualPath(responseModel[0].UserManual);
            }
            else {
                setUserManualPath(null);
            }
            if (responseModel[0].WarrantyRegForm !== null && responseModel[0].WarrantyRegForm !== "") {
                setWarrentyPath(responseModel[0].WarrantyRegForm);
            }
            else {
                setWarrentyPath(null);
            }
            if (responseModel[0].KitAssemblyInstructions !== null && responseModel[0].KitAssemblyInstructions !== "") {
                setKitPath(responseModel[0].KitAssemblyInstructions);
            }
            else {
                setKitPath(null);
            }
            if (responseModel[0].ModelCode !== null && responseModel[0].ModelCode !== "") {
                setModelCode(responseModel[0].ModelCode);
            }
            else {
                setModelCode(responseModel[0].ModelCode);
            }



        }
    }, [responseModel])

    useEffect(() => {
        debugger;
        if (responseModelDtls.length > 0) {
            if (responseModelDtls[0].ModelCode !== null && responseModelDtls[0].ModelCode !== "") {
                setModelCode(responseModelDtls[0].ModelCode);
            }
            if (responseModelDtls[0].ModelID !== null && responseModelDtls[0].ModelID !== "") {
                setModelID(responseModelDtls[0].ModelID);
                getModelPath(responseModelDtls[0].ModelID);
            }

        }
    }, [responseModelDtls])

    useEffect(() => {
        const gridCols = [
            {
                field: "id",
                headerName: "Select",
                //renderCell: (params) => (<strong> <Link to={{ pathname: "/SerialNumberList/UpdateSerialNumberView", state: { MfgBatchID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
                renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong>),
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 120,
            },
            {
                field: "MfgBatchNo",
                headerName: "Mfg Batch No",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "MfgDate",
                headerName: "Mfg Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            {
                field: "ModelCode",
                headerName: "Model No",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            {
                field: "ModelName",
                headerName: "Model Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 170,
            },
            {
                field: "MfgQty",
                headerName: "Mfg Qty",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            {
                field: "Remarks",
                headerName: "Remarks",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },

            {
                field: "CreatedByID",
                headerName: "Created By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            {
                field: "CreatedOn",
                headerName: "Created On ",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            {
                field: "ModifiedByID",
                headerName: "Modified By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            {
                field: "ModifiedOn",
                headerName: "Modified On",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },

        ];
        setColumns(gridCols);
        setRows(response);
        setCount(response.length);
    }, [response]
    );

    useEffect(() => {
        PopulatebData();
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        console.log(params.SerialNo);
        console.log(params.ModelID);
        setModelID(params.ModelID);
        setSerialNo(params.SerialNo);
        getModelDtls(params.SerialNo);

    }, [])

    return (
        <div>
            <div className={classes.container}>
                <div style={{ width: "115%" }}>
                    <Formik
                        initialValues={{
                            FromDate: FromDate,
                            ToDate: ToDate,
                        }}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                        enableReinitialize
                    >
                        {(formik) => {
                            return (

                                <Form>
                                    <Grid container="row">
                                        <Grid xs={12} sm={12} lg={4} xl={4}>
                                            <div width="10%" height="10%">
                                                <img src={LogoColor} alt="PM Logo" />
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} marginTop={1}>
                                            <label style={{ fontSize: 16, fontWeight: "bold" }}>
                                                Dear Customer, using the below link you can download the documents related to your device.
                                            </label>
                                        </Grid>
                                    </Grid>
                                    <Grid container="row">
                                        <label style={{ fontSize: 18, fontWeight: "bold", marginTop: 4 }}>Model No : {ModelCode}</label>
                                    </Grid>
                                    <Grid container="row">
                                        <label style={{ fontSize: 18, fontWeight: "bold", marginTop: 4 }}>Serial No : {SerialNo}</label>
                                    </Grid>
                                    {/* <Grid container="row">
                                        <Grid item xs={12} sm={12} lg={4} xl={4} alignContent="center" style={{ marginLeft: 20 }}>
                                            <BiztranControls.Button
                                                style={{ width: "300px" }}
                                                //type="submit"
                                                text={"CE Certificate"}
                                                
                                                onClick={downloadCECertificate}
                                            ></BiztranControls.Button>
                                        </Grid>
                                    </Grid> */}
                                    <Grid container="row">
                                        <Grid item xs={12} sm={12} lg={4} xl={4} alignContent="center" style={{ marginLeft: 20 }}>
                                            <BiztranControls.Button
                                                style={{ width: "300px" }}
                                                //type="submit"
                                                text={"Warranty Registration Form"}
                                                onClick={downloadWarrentyForm}
                                            //onClick={onSave}
                                            ></BiztranControls.Button>
                                        </Grid>
                                    </Grid>
                                    <Grid container="row">
                                        <Grid item xs={12} sm={12} lg={4} xl={4} alignContent="center" style={{ marginLeft: 20 }}>
                                            <BiztranControls.Button
                                                style={{ width: "300px" }}
                                                //type="submit"
                                                text={"User Manual"}
                                                onClick={downloadUserManual}
                                            //onClick={onSave}
                                            ></BiztranControls.Button>
                                        </Grid>
                                    </Grid>
                                    <Grid container="row">
                                        <Grid item xs={12} sm={12} lg={4} xl={4} alignContent="center" style={{ marginLeft: 20 }}>
                                            <BiztranControls.Button
                                                style={{ width: "300px" }}
                                                //type="submit"
                                                text={"Kit Assembly Instructions"}
                                                onClick={downloadKitInstruction}
                                            //onClick={onSave}
                                            ></BiztranControls.Button>
                                        </Grid>
                                    </Grid>



                                </Form>
                            );
                        }}
                    </Formik>
                </div>
            </div>
        </div>
    );
};

const useStyles = makeStyles((theme) => ({
    iconStyle: {
        color: theme.palette.primary.button,
    },
    container: {
        fontFamily: theme.palette.primary.fontFamily,
        padding: 20
    }, gridItem: {
        paddingTop: "0px !important", marginTop: "1.5rem !important", marginRight: "1.5rem !important"
    }
}));


export default Cecertificate;